<template>
    <div class="default-box">
        <!--<v-autocomplete
            v-model="selectedDepartment"

            :items="departments"

            item-text="name"
            item-value="name"

            label="Select department"

            persistent-hint
            return-object
            single-line
        />-->

        <h2>Choose a time period:</h2>
        <v-checkbox
            v-model="useSpecificRange"
            label="Manually pick date range"
        />

        <v-container class="date-select" v-if="useSpecificRange">
            <v-row>
                <v-col>
                    <h2>From</h2>
                    <v-date-picker
                        class="date-picker mb-4"
                        v-model="dateFrom"
                        :min="minDateFrom"
                    />
                </v-col>

                <v-col>
                    <h2>To</h2>
                    <v-date-picker
                        class="date-picker"
                        v-model="dateTo"
                    />
                </v-col>
            </v-row>
        </v-container>

        <v-container v-else>
            <v-select
                v-model="selectedRange"

                label="Select date range"

                :items="predefinedRanges"
            />
        </v-container>

        <v-btn @click="submitSaleSearch()">Submit search</v-btn>
    </div>
</template>

<script>
export default {
    name: "SalestatOptions",

    data() {
        return {
            departments: [],

            selectedDepartment: {},

            minDateFrom: '2000-01-01',

            useSpecificRange: false,
            dateFrom: '2020-01-01',
            dateTo: '2021-11-04',

            selectedRange: '',
            predefinedRanges: [
                'This week',
                'This month',
                'This year'
            ],

            saleStatistics: null
        }
    },

    mounted() {
        this.$store.getters.getDepartments.then(departments => {
            this.departments = departments
        });
    },

    methods: {
        submitSaleSearch() {
            var dateFrom = new Date(this.dateFrom);
            var dateTo = new Date(this.dateTo);

            const departmentId = this.selectedDepartment.id;

            this.$store.dispatch("submitSaleSearch", {
                departmentId: departmentId,
                from: dateFrom,
                to: dateTo,
                preset: this.useSpecificRange ? null : this.selectedRange
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SalestatOptions.vue